import range from './range';
export default function zip(...args) {
    const minLength = Math.min(...args.map(arr => arr.length));
    // @ts-expect-error This is too much for ts
    return range(minLength).map((i) => args.map(arr => arr[i]));
}
;
